import { rest } from 'msw';

import { getWebpackEnvVar, getEnvironment } from '@trqk/utils';

import { users } from './data';

const cognitoIdentityUrl = getWebpackEnvVar('web', 'AWS_COGNITO_IDENTITY_URL');
const identityPoolIdForEnv = getWebpackEnvVar('web', 'AWS_IDENTITY_POOL_ID');
const environment = getEnvironment();

/**
 * Cognito uses two endpoints to authenticate users when using Auth.signIn() as we are doing in
 * packages/e2e/web/cypress/support/auth-provider-commands/cognito.js. This handler is for the
 * endpoint starting in 'cognito-identity', for example:
 * https://cognito-identity.us-east-1.amazonaws.com/
 */
export const cognitoIdentityHandler = rest.post(
    cognitoIdentityUrl,
    (req, res, ctx) => {
        if (typeof req.body === 'object') {
            const identityPoolId = req?.body?.IdentityPoolId ?? null;

            /**
             * Begin logic for testUserPublisher
             */

            if (identityPoolId === identityPoolIdForEnv) {
                return res(
                    ctx.json(
                        users.publisher.cognitoIdentity.identityIdResponse[
                            environment
                        ],
                    ),
                );
            }

            /**
             * End logic for testUserPublisher
             */
        }

        return res();
    },
);
